import React, { ReactElement, PureComponent } from 'react';
import { connect } from 'react-redux';
import config from '~/config';
import { fetchCurrenciesIfNeeded as fetchCurrencies, selectCurrency } from '~/Currency';
import { handleError } from '~/ErrorHandler';
import { fetchPrices, State as ProductPriceState } from '~/ProductPrice';
import { ThunkAction } from '~/Store';

import DetailModal from './DetailModal';

interface Props {
	children: ReactElement<DetailModal['props'], DetailModal['render']>;
	productId: string;
	currency: string | null;
	isFetching: boolean;
	onLoad(a: string, b: string | null): any;
}

class PricesContainer extends PureComponent<Props> {
	componentDidMount() {
		const { productId, currency, onLoad } = this.props;
		onLoad(productId, currency);
	}

	componentDidUpdate(prevProps: Props) {
		const { productId, currency, onLoad } = this.props;
		if (prevProps.productId !== productId || prevProps.currency !== currency) {
			onLoad(productId, currency);
		}
	}

	render() {
		const { isFetching, children } = this.props;
		return React.cloneElement(children, { isFetchingPrices: isFetching });
	}
}

function mapStateToProps(state: { productPrice: ProductPriceState }): {
	isFetching: boolean;
} {
	return {
		isFetching: state.productPrice.request !== null,
	};
}

function fetch(productId: string, currency: string | null): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		if (currency === config.product.defaultPriceCurrency) {
			return;
		}
		if (currency && !selectCurrency(await dispatch(fetchCurrencies()), currency)) {
			return;
		}
		try {
			await dispatch(fetchPrices([productId], currency));
		} catch (e) {
			dispatch(handleError(e));
		}
	};
}

const actions: { onLoad: typeof fetch } = {
	onLoad: fetch,
};

export default connect(mapStateToProps, actions)(PricesContainer);
